import React from 'react'
import PageTitle from '../Components/PageTitle'
import Navbar from '../Components/Header'
import AboutMain from '../Components/AboutMain'
import OurBusinessPart1 from '../Components/OurB1'
import Footer from '../Components/Footer'
import FaqAbout from '../Components/FaqAbout'
import Gallery from '../Components/Gallery'
import { Helmet } from 'react-helmet'

function MainAboutPage() {
  return (
    <>
    <Helmet>
                <meta name='description' content='Who we Are'/>
                <title>About - Tisson Lanka</title>
                <link rel="canonical" href="/About" />
    </Helmet>
    <Navbar/>
    <PageTitle content="About Us"/>
    <AboutMain/>
    <OurBusinessPart1/>
    <Gallery/>
    <FaqAbout/>
    <Footer/>
    </>
  )
}

export default MainAboutPage